import React from 'react';
import Dialog from 'material-ui/Dialog';
import { Link } from 'react-router-dom';

import './alert.css';

const AutzuPlus = ({ closeDialog, isDialogOpen }) => (
  <Dialog open={isDialogOpen} paperProps={{ style: { borderRadius: '4px' } }}>
    <i role="presentation" className="fa fa-times close" onClick={closeDialog} />
    <p style={{ textAlign: 'center', marginTop: '30px' }}>
      Autzu PLUS is a special option. If you are interested in driving our PLUS vehicles, please take the course, and
      feel free to contact us with any questions!
    </p>

    <div className="plus-buttons-div">
      <Link to="/course">
        <button type="button" className="alert-button" onClick={closeDialog}>
          TAKE THE COURSE
        </button>
      </Link>
      <Link to="/plus">
        <button type="button" className="alert-button" onClick={closeDialog}>
          AUTZU PLUS
        </button>
      </Link>
    </div>
  </Dialog>
);

export default AutzuPlus;



// WEBPACK FOOTER //
// ./src/components/Alert/AutzuPlus.js